import { StaticDependenciesService } from '@cinetixx/cinetixx-ui';

export class SvgPolylineBuilder {

  private _polyline: SVGPolylineElement;
  private _text: SVGTextElement;
  private readonly _strokePolyline = '#b1b2b2';
  private readonly _strokeText = '#1269B0';

  public withPolyline(points: string): SvgPolylineBuilder {
    if (!points) {
      return this;
    }

    this._polyline = StaticDependenciesService.document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    this._polyline.setAttribute('points', points);
    this._polyline.setAttribute('fill', 'none');
    this._polyline.setAttribute('stroke', this._strokePolyline);
    this._polyline.setAttribute('stroke-width', '1');
    this._polyline.setAttribute('stroke-dasharray', '5,5');

    return this;
  }

  public withText(x: string, y: string, textContent: string): SvgPolylineBuilder {
    if (!textContent || !x || !y) {
      return this;
    }

    this._text = StaticDependenciesService.document.createElementNS('http://www.w3.org/2000/svg', 'text');
    this._text.setAttribute('text-anchor', 'end');
    this._text.setAttribute('font-size', '14');
    this._text.setAttribute('stroke', this._strokeText);
    this._text.setAttribute('x', x);
    this._text.setAttribute('y', y);
    this._text.style.userSelect = 'none';
    this._text.textContent = textContent;

    return this;
  }

  public build(rankToken: string): SVGElement {
    const svg = StaticDependenciesService.document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.style.zIndex = '9998';
    svg.classList.add('pointer-events-none');
    svg.classList.add('row-svg');
    svg.classList.add('full-width');
    svg.classList.add('full-height');
    svg.classList.add('position-absolute');
    svg.appendChild(this._polyline);
    svg.appendChild(this._text);
    svg.id = rankToken;

    return svg;
  }
}
